import veritoneApi from './veritoneApi';
import _, { includes } from 'lodash';
import constant from './constant';

const GET_ROLE = ()  => `
    {
        me {
            roles {
              appName
              id
              name
            }
          }
    }
`;


export function getRoleApi(urlApi) {
    return veritoneApi(urlApi.graphql).post('', { query: GET_ROLE() })
        .then(response => {
            return _.get(response, 'data.data.me.roles', [])
        })
        .catch(error => [])
}

export function userLogoutApi(urlApi) {
    return veritoneApi(urlApi.baseUrl)
      .get('/user/logout')
      .then(response => response.data)
      .catch(error => error);
}
